'use strict';

(function ($) {
  function initChoices(){
    let els = $('.block.form select:not(.choices__input)');
    els.each(function(){
      const choices = new Choices($(this)[0], {
        searchEnabled: false,
        itemSelectText: '',
        allowHTML: false
      });
    });
  }

  $(document).ready(function (){
    initChoices();
  })

  // Check for DOM changes and re-init choices where necessary.
  MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  let observer = new MutationObserver(function(mutations, observer) {
    initChoices();
  });
  observer.observe(document, {
    subtree: true,
    attributes: true
  });

})(jQuery);